/* unplugin-vue-components disabled */import script from "./NoticePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticePopup.vue?vue&type=script&setup=true&lang=js"

import "./NoticePopup.vue?vue&type=style&index=0&id=dcc6892e&lang=less&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/6e3ae807-c557-4a09-aaa1-df42e37b9e5a/workspace/pc-FTZCOIN_fvgL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcc6892e"]])

export default __exports__